/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports PingTimeBean
 */
export default class PingTimeBean {
    constructor() {
        this.pingsCounter = 0;
        this.pingsTime = 0;
    }
    add(pingTime) {
        this.pingsTime = this.pingsTime + pingTime;
        this.pingsCounter++;
    }
    getAvgPingTime() {
        return this.pingsTime / this.pingsCounter;
    }
}
